import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import FaqHero from './components/FaqHero';
import FaqAccordion from './components/FaqAccordion';
import FaqCta from './components/FaqCta';
import { useTitle } from '@/hooks/useTitle';

import PageCta from '@/components/feature/PageCta';

export default function Faq() {
  useTitle({
    title: '常見問答｜保險建築師 FAQ 保險知識',
    description: '保險建築師為您整理最常見的保險問題，包含保單選擇、理賠流程、保費計算等實用解答。',
  });
  return (
    <main>
      <Navbar />
      <FaqHero />
      <FaqAccordion />
      <FaqCta />
      <PageCta />
      <Footer />
    </main>
  );
}
